import { Box } from '@mui/material';

import { selectImpactCo2AnswersExternalAndValidated } from '@/domain/impact-co2/impact-co2.selectors';
import { translate } from '@/ui/i18n';

import { ImpactQuestionContext } from '../ImpactQuestionContext';
import { Co2QuizFormData } from './Co2QuizFormData';
import { QuizFormSeparator } from './components/QuizFormSeparator';
import { ImpactForm } from './ImpactForm';

export function Co2QuizExternalAnswers({
  projectId,
  form,
}: {
  projectId: number;
  form?: Co2QuizFormData;
}) {
  if (form === undefined) {
    return null;
  }
  return (
    <Box>
      {form.sections.map((section) => (
        <Box
          key={section.sectionKey}
          id={`${section.sectionKey.toLowerCase()}-form`}
        >
          <QuizFormSeparator
            label={translate(`Co2.Sections.${section.sectionKey}`)}
          />
          {section.questions.map((category) => (
            <ImpactQuestionContext.Provider
              // override the context to make the form not editable and set the answers selector
              key={category}
              value={{
                panelOpen: false,
                hideCompleted: false,
                answersSelectorOverride:
                  selectImpactCo2AnswersExternalAndValidated({
                    sector: form.sector,
                    category: category,
                  }),
              }}
            >
              <ImpactForm
                projectId={projectId}
                sector={form.sector}
                category={category}
                isExternal={true}
              />
            </ImpactQuestionContext.Provider>
          ))}
        </Box>
      ))}
    </Box>
  );
}
